import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)
const state = {
	// imageNoteStatus:'',
}
const actions = {


}
const mutations = {

}
export default {
	state,
	actions,
	mutations
}
